import type { StyledComponent } from 'styled-components';
import styled from 'styled-components';
import type { TreeProps } from 'antd/lib/tree';
import { Tree, Empty } from '../ui';
import type { TreeNode } from './types';

export const StyledFinder: StyledComponent<typeof Tree, TreeProps<TreeNode>> = styled(Tree)`
  height: 100%;

  .ant-tree-list {
    height: 100%;

    .ant-tree-node-content-wrapper {
      .ant-tree-iconEle {
        width: auto;

        .ant-tag {
          margin-top: 2px;

          .anticon {
            margin-right: 2px;
          }
        }
      }
    }
  }

  .ant-tree-treenode-selected {
    background: var(--ant-primary-1);
    box-shadow: 0 1px 0 #cbe6ff, 0px -1px 0 #cbe6ff;
  }

  .ant-tree-node-content-wrapper.ant-tree-node-selected {
    background: transparent;
  }

  .ant-tree-node-content-wrapper:hover {
    background: transparent;
  }

  .ant-tree-treenode {
    padding: 0;
    transition: all 0.3s, border 0s, line-height 0s, box-shadow 0s;
  }

  .ant-tree-treenode:not(.ant-tree-treenode-selected):nth-child(odd) {
    background: #fafafa;
  }

  .ant-tree-treenode:hover:nth-child(odd),
  .ant-tree-treenode:hover {
    background: #fafafa;
  }

  .ant-tree-node-content-wrapper {
    display: flex;
  }

  .ant-tree-title {
    flex: auto;
    white-space: nowrap;
    width: 1px;
    .ant-tag.ant-tag-small {
      overflow: initial;
      text-overflow: unset;
    }
    span {
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .ant-tree-iconEle {
    flex: 0 0 20px;
  }

  .ant-dropdown-trigger {
    width: 100%;
    display: inline-block;
  }
`;

export const StyledTitle = styled.span`
  display: flex;
  align-items: center;
`;

export const StyledEmpty = styled(Empty)`
  height: 100%;
`;
